import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import Trend from 'react-trend'

import BrowserWindow from './campaigns/previews/BrowserWindow'
import FacebookPost from './campaigns/previews/FacebookPost'
import PushPreview from './campaigns/previews/PushPreview'
import SMSPreview from './campaigns/previews/SMSPreview'

import { getRandomInt, randomDataArr } from '../helpers';

const campaignPrevew = (type, content) => {
  switch (type) {
    case 'facebook':
      return <FacebookPost 
        image={content.image}
        title={content.title}
        descr={content.descr}
        url={content.url} />
    case 'email':
      return <BrowserWindow {...content} />
    case 'push':
      return <PushPreview state={content} />
    case 'sms':
      return <SMSPreview state={content} />
    default:
      break;
  }
}

const CampaignPage = ({
  history,
  location,
  match,
  campaign,
}) => {
  if (campaign) {
    const { type, name, preview, stats, content } = campaign;
    return (
      <div className="container content">
        <h2>{ name }</h2>
        <div className="graph">
          <Trend
            // smooth
            autoDraw
            autoDrawDuration={3000}
            autoDrawEasing="ease-out"
            data={randomDataArr(12)}
            gradient={['#00c6ff', '#F0F', '#FF0']}
            radius={10}
            strokeWidth={1}
            strokeLinecap={'butt'}
          />
          <div className="graph__y">
            <div className="graph__label">5000</div>
            <div className="graph__label">10000</div>
            <div className="graph__label">15000</div>
            <div className="graph__label">20000</div>
            <div className="graph__label">25000</div>
            <div className="graph__label">30000</div>
          </div>
          <div className="graph__x">
            <div className="graph__label">July</div>
            <div className="graph__label">August</div>
            <div className="graph__label">September</div>
            <div className="graph__label">October</div>
            <div className="graph__label">November</div>
            <div className="graph__label">December</div>
          </div>
        </div>
        {/* <div className="columns">
          <div className="column">
            <div className="campaign__block">
              <img className="campgn__preview" src={preview} alt=""/>
            </div>
          </div>
          <div className="column flex-column">
            <div className="campgn__stat">
              <div>
                <div className="campgn__digit">{getRandomInt(1000, 5000)}</div>
                <div className="campgn__label">Impressions</div>
              </div>
              <Trend
                // smooth
                width={150} height={40}
                padding={0}
                autoDraw
                autoDrawDuration={1000}
                autoDrawEasing="ease-out"
                data={randomDataArr(6)}
                gradient={['#00c6ff', '#F0F', '#FF0']}
                radius={10}
                strokeWidth={1}
                strokeLinecap={'butt'}
              />
            </div>
            <div className="campgn__stat">
              <div>
                <div className="campgn__digit">{getRandomInt(10, 100)}%</div>
                <div className="campgn__label">Open Rate</div>
              </div>
              <Trend
                // smooth
                width={150} height={40}
                padding={0}
                autoDraw
                autoDrawDuration={1000}
                autoDrawEasing="ease-out"
                data={randomDataArr(6)}
                gradient={['#00c6ff', '#F0F', '#FF0']}
                radius={10}
                strokeWidth={1}
                strokeLinecap={'butt'}
              />
            </div>
            <div className="campgn__stat">
              <div>
                <div className="campgn__digit">{getRandomInt(10, 100)}%</div>
                <div className="campgn__label">Click Rate</div>
              </div>
              <Trend
                // smooth
                width={150} height={40}
                padding={0}
                autoDraw
                autoDrawDuration={1000}
                autoDrawEasing="ease-out"
                data={randomDataArr(6)}
                gradient={['#00c6ff', '#F0F', '#FF0']}
                radius={10}
                strokeWidth={1}
                strokeLinecap={'butt'}
              />
            </div>
            <div className="campgn__stat">
              <div>
                <div className="campgn__digit">{getRandomInt(10, 300)}</div>
                <div className="campgn__label">CTA</div>
              </div>
              <Trend
                // smooth
                width={150} height={40}
                padding={0}
                autoDraw
                autoDrawDuration={1000}
                autoDrawEasing="ease-out"
                data={randomDataArr(6)}
                gradient={['#00c6ff', '#F0F', '#FF0']}
                radius={10}
                strokeWidth={1}
                strokeLinecap={'butt'}
              />
            </div>
          </div>
          <div className="column">
            <div className="campaign__block">
              { campaignPrevew(type, content) }
            </div>
          </div>
        </div> */}
        <div className="campgn__stats">
          <div className="campgn__stat">
            <div>
              <div className="campgn__digit">{stats.impressions}</div>
              <div className="campgn__label">Impressions</div>
            </div>
            <Trend
              // smooth
              width={150} height={40}
              padding={0}
              autoDraw
              autoDrawDuration={1000}
              autoDrawEasing="ease-out"
              data={randomDataArr(6)}
              gradient={['#00c6ff', '#F0F', '#FF0']}
              radius={10}
              strokeWidth={1}
              strokeLinecap={'butt'}
            />
          </div>
          <div className="campgn__stat">
            <div>
              <div className="campgn__digit">{stats.openrate}%</div>
              <div className="campgn__label">Open Rate</div>
            </div>
            <Trend
              // smooth
              width={150} height={40}
              padding={0}
              autoDraw
              autoDrawDuration={1000}
              autoDrawEasing="ease-out"
              data={randomDataArr(6)}
              gradient={['#00c6ff', '#F0F', '#FF0']}
              radius={10}
              strokeWidth={1}
              strokeLinecap={'butt'}
            />
          </div>
          <div className="campgn__stat">
            <div>
              <div className="campgn__digit">{stats.clickrate}%</div>
              <div className="campgn__label">Click Rate</div>
            </div>
            <Trend
              // smooth
              width={150} height={40}
              padding={0}
              autoDraw
              autoDrawDuration={1000}
              autoDrawEasing="ease-out"
              data={randomDataArr(6)}
              gradient={['#00c6ff', '#F0F', '#FF0']}
              radius={10}
              strokeWidth={1}
              strokeLinecap={'butt'}
            />
          </div>
          <div className="campgn__stat">
            <div>
              <div className="campgn__digit">{stats.cta}</div>
              <div className="campgn__label">CTA</div>
            </div>
            <Trend
              // smooth
              width={150} height={40}
              padding={0}
              autoDraw
              autoDrawDuration={1000}
              autoDrawEasing="ease-out"
              data={randomDataArr(6)}
              gradient={['#00c6ff', '#F0F', '#FF0']}
              radius={10}
              strokeWidth={1}
              strokeLinecap={'butt'}
            />
          </div>
        </div>
      </div>
    )
  } else {
    return <Redirect to="/campaigns"/>
  }
}

// export default Campaign
function mapStateToProps(state, props) {
  const campaigns = state.campaigns.active;
  const campaign = campaigns.find(item => item.id == props.match.params.id);
  return { campaign }
}


export default connect(mapStateToProps)(CampaignPage)


// WEBPACK FOOTER //
// ./src/components/CampaignPage.js